import React, { useState } from "react";

export default function CustomsClearance() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;

    setTimeout(() => {
      setLoading(false);
      setDone(true);
      form.reset();
      setTimeout(() => setDone(false), 3000);
    }, 1500);
  };

  return (
    <>
      {/* ⭐ INLINE CSS */}
      <style>{`
        .banner {
          height: 350px;
          background: url('/slider1.jpg') center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
        }

        .banner::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }

        .banner h1 {
          z-index: 2;
          font-size: 48px;
          font-weight: 800;
        }

        .section {
          padding: 90px 0;
        }

        .glass-card {
          background: rgba(255,255,255,0.92);
          padding: 45px;
          border-radius: 22px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.12);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(0,0,0,0.08);
          animation: fadeUp 1s ease;
          margin-bottom: 60px;
        }

        .title {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 20px;
          position: relative;
        }

        .title::after {
          content: "";
          width: 100px;
          height: 5px;
          background: linear-gradient(90deg, #005eff, #f80b0b);
          position: absolute;
          bottom: -8px;
          left: 0;
          border-radius: 5px;
        }

        .text {
          font-size: 17px;
          color: #444;
          line-height: 1.85;
        }

        .feature-box {
          padding: 22px;
          border-radius: 18px;
          background: white;
          border-left: 6px solid #005eff;
          box-shadow: 0px 10px 25px rgba(0,0,0,0.12);
          margin-bottom: 22px;
        }

        .customs-form {
          margin-top: 70px;
          background: white;
          padding: 45px;
          border-radius: 22px;
          box-shadow: 0px 20px 45px rgba(0,0,0,0.12);
          animation: fadeUp 1s ease;
        }

        .form-label {
          font-weight: 600;
          color: #222;
        }

        .form-control-custom,
        .form-select-custom {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: 1px solid #cfd6ff;
          font-size: 15px;
          transition: 0.25s ease;
        }

        .form-control-custom:focus,
        .form-select-custom:focus {
          border-color: #005eff;
          box-shadow: 0 0 8px rgba(0,94,255,0.35);
        }

        .submit-btn {
          width: 100%;
          padding: 16px;
          background: linear-gradient(90deg, #005eff, #003fc8);
          color: #fff;
          font-size: 18px;
          font-weight: 700;
          border: none;
          border-radius: 14px;
          transition: .3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0px 12px 22px rgba(0,94,255,0.35);
        }

        .loading-text {
          margin-top: 12px;
          color: #005eff;
          font-weight: 600;
        }

        .success-text {
          margin-top: 12px;
          color: green;
          font-weight: 600;
        }

        .faq-box {
          background: #f4f7ff;
          padding: 18px;
          border-radius: 12px;
          border-left: 4px solid #005eff;
          margin-bottom: 12px;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ BANNER */}
      <div className="banner">
        <h1>Customs Clearance</h1>
      </div>

      {/* ⭐ MAIN CONTENT */}
      <section className="section">
        <div className="container">

          {/* ⭐ INTRO */}
          <div className="glass-card">
            <h2 className="title">Fast, Compliant & Hassle-Free U.S. Customs Clearance</h2>

            <p className="text">
              Importing or exporting goods across international borders requires expert handling 
              of customs regulations, taxes, compliance documentation, HS codes, inspections and 
              government approvals. Even a small mistake in paperwork can cause costly delays, 
              penalties or shipment seizures.
            </p>

            <p className="text">
              SWIFTSHIP’s Customs Clearance Division helps businesses navigate the complexities of 
              U.S. Customs & Border Protection (CBP) requirements with complete transparency and 
              accuracy. Our licensed brokers ensure that every shipment — whether air, ocean, or 
              express — clears customs smoothly and on time.
            </p>

            <p className="text">
              We manage the full compliance workflow including ACE filings, commercial documentation, 
              import/export declarations, tariff classifications, bonded shipments, FDA & USDA controls, 
              and duties/tax assessments for all international freight.
            </p>
          </div>

          {/* ⭐ FEATURES SECTION */}
          <h2 className="title">Our Customs Clearance Capabilities</h2>

          <div className="feature-box">
            <h5 className="fw-bold">✔ HS Code Classification & Tariff Consulting</h5>
            <p className="text">
              Accurate HS coding ensures the correct duty/tax rate is applied and minimizes the 
              risk of customs audits or shipment delays.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Importer Security Filing (ISF 10+2)</h5>
            <p className="text">
              Required for all ocean imports into the U.S. We handle ISF filing and ensure 
              compliance with CBP timelines to avoid penalties.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ ACE Import & Export Entry Filings</h5>
            <p className="text">
              We process all entries through the Automated Commercial Environment (ACE) for 
              faster CBP clearance.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ FDA, USDA, EPA & PGAs Compliance</h5>
            <p className="text">
              We coordinate with government agencies for goods requiring special permits or 
              inspections — food, cosmetics, medical devices, chemicals, and more.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Duty & Tax Calculations</h5>
            <p className="text">
              Transparent duty assessments based on product classification, trade agreements, 
              country-of-origin regulations and preferential tariffs.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Bonded Warehousing & In-Transit Customs Control</h5>
            <p className="text">
              If goods need to move through the U.S. without paying duties immediately, 
              we manage bonded shipments and secure bonded storage.
            </p>
          </div>

          {/* ⭐ INDUSTRIES */}
          <h2 className="title mt-5">Industries We Serve</h2>

          <ul className="text">
            <li>✔ Electronics & High-Tech Imports</li>
            <li>✔ Pharmaceuticals & Medical Devices</li>
            <li>✔ Apparel, Footwear & Retail Goods</li>
            <li>✔ Automotive Parts & Machinery</li>
            <li>✔ Food, Beverages & Perishable Imports</li>
            <li>✔ Chemicals & Hazardous Goods</li>
            <li>✔ E-commerce Cross-Border Sellers</li>
            <li>✔ International Manufacturers & Distributors</li>
          </ul>

          {/* ⭐ FAQ SECTION */}
          <h2 className="title mt-5">Customs Clearance FAQs</h2>

          <div className="faq-box">
            <strong>Q: How long does U.S. customs clearance take?</strong>
            <p className="text">Usually 24–72 hours depending on shipment type and documentation accuracy.</p>
          </div>

          <div className="faq-box">
            <strong>Q: What documents are required?</strong>
            <p className="text">Commercial invoice, packing list, HS codes, bill of lading/airway bill and permits if required.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Can SWIFTSHIP act as my customs broker?</strong>
            <p className="text">Yes — we handle full customs brokerage services for all importers & exporters.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Do you help with duties & tax optimization?</strong>
            <p className="text">Yes, we assist with tariff classifications, exemptions, and trade program eligibility.</p>
          </div>

          {/* ⭐ HIGH-CONVERSION FORM */}
          <form className="customs-form" onSubmit={handleSubmit}>
            <h3 className="fw-bold mb-4">Request a Customs Clearance Quote</h3>

            <div className="row g-3">

              <div className="col-md-6">
                <label className="form-label">Full Name</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Email Address</label>
                <input type="email" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Type of Shipment</label>
                <select className="form-select-custom" required>
                  <option value="">Select Shipment Type</option>
                  <option>Air Freight</option>
                  <option>Ocean Freight</option>
                  <option>Courier (DHL/UPS/FedEx)</option>
                  <option>Bulk Cargo</option>
                  <option>Hazardous Goods</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Origin Country</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Product Category</label>
                <select className="form-select-custom" required>
                  <option>Electronics</option>
                  <option>Medical Supplies</option>
                  <option>Automotive Parts</option>
                  <option>Food / Beverages</option>
                  <option>Cosmetics</option>
                  <option>Chemicals</option>
                  <option>General Merchandise</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label">Describe Your Shipment</label>
                <textarea className="form-control-custom" rows="4" required></textarea>
              </div>

            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit Request"}
            </button>

            {loading && <div className="loading-text">Please wait...</div>}
            {done && <div className="success-text">Your customs clearance request has been submitted!</div>}
          </form>

        </div>
      </section>
    </>
  );
}
